export const picsUrls: {
    id: number;
    desktopSrc?: string;
    mobileSrc?: string;
}[] = [
    {
        id: 1,
        desktopSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor1%401x.jpg',
        mobileSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor1%401x.jpg',
    },
    {
        id: 2,
        desktopSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor2%401x.jpg',
        mobileSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor2%401x.jpg',
    },
    {
        id: 3,
        desktopSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor3%401x.jpg',
        mobileSrc:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/whatIsItFor/whatsIsItFor3%401x.jpg',
    },
];
